<template>
	<div class="flex1" style="height:100%">
		<Title :title="'行驶里程'"></Title>
		<echarts v-if="showcdata" :id="'changeMiles'" :options="cdata" />
	</div>
</template>

<script>
	import echarts from '../charts/echarts.vue'
	import Title from '../title.vue'
	import {
		dataInterface
	} from '@/api/dataInterfaceApi';
	export default {
		data() {
			return {
				showcdata: false,
				// title:"车辆新增及活跃趋势",
				cdata: {
					legend: {
						right: 'left',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
					},
					xAxis: {
						type: 'category',
						boundaryGap: false
					},
					yAxis: {
						type: 'value',
						splitLine:false
					},
					legendData:[{
							name:"新增数",
							icon: 'roundRect',
						}, {
							name:"活跃数",
							icon: 'roundRect',
					}],
					series: []
				}
			};
		},
		components: {
			echarts,
			Title
		},
		mounted() {
			this.getBattery24hours()
		},
		methods: {
			//获取24小时电次数分布
			getBattery24hours() {
				let params = {
				  "enCode": "per_vehicle-行驶里程-全国车辆均值",
				  "@VEHICLE_VIN": localStorage.getItem("newVehicleNum") ? localStorage.getItem("newVehicleNum") : 'LDP31B967MG929008'
				}
				dataInterface.dataFaceApi(params).then((res) => {
					console.log(res,'resper_vehicle-行驶里程-全国车辆均值')
					if(res) {
						let series1 = {
							name: '行驶里程',
							type: 'line',
							stack: 'Total',
							smooth: true,
							lineStyle: {
								width: 2,
								color: '#3689E3'
							},
							showSymbol: false,
							emphasis: {
								focus: 'series'
							},
							itemStyle: {
								normal: {
									color: '#3689E3', //改变折线点的颜色
									lineStyle: {
										color: '#3689E3' //改变折线颜色
									}
								}
							}
						}
						let series2 = {
							name: '车辆行驶里程均值',
							type: 'line',
							stack: 'Total',
							smooth: true,
							lineStyle: {
								width: 2,
								color: '#73E7AD'
							},
							showSymbol: false,
							emphasis: {
								focus: 'series'
							},
							itemStyle: {
								normal: {
									color: '#73E7AD', //改变折线点的颜色
									lineStyle: {
										color: '#73E7AD' //改变折线颜色
									}
								}
							}
						}
						let data1 = []
						let data2 = []
						let xAxis = []
						res.forEach(item => {
							xAxis.push(item.cur_date)
							data1.push(item.driver_mileage)
							data2.push(item.avg_diver_mileage)
						})
						this.cdata.xAxis.data = xAxis
						series1.data = data2
						this.cdata.series.push(series1)
						series2.data = data1
						this.cdata.series.push(series2)
						this.showcdata = true
					}
				}).catch((err) => {
					console.log(err);
				  });
			}
		}
	};
</script>

<style lang="scss" scoped>
@import './comm.scss';
</style>

